import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Employee } from "../state/types"

export const useEmployeeActions = () => {
    const saveActions = useSaveActions()

    const saveEmployee = (employee: Employee) => {
        const { save } = saveActions()
        return save(TableName.EMPLOYEES, employee) as Promise<Employee>
    }

    const removeEmployee = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.EMPLOYEES, id)
    }

    return {
        saveEmployee,
        removeEmployee
    }
}
